import { render } from "./PeopleList.vue?vue&type=template&id=62e43eab&scoped=true"
import script from "./PeopleList.vue?vue&type=script&lang=js"
export * from "./PeopleList.vue?vue&type=script&lang=js"

import "./PeopleList.vue?vue&type=style&index=0&id=62e43eab&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62e43eab"]])

export default __exports__